
import React from 'react';

import {Helmet, translate} from 'views/module';

import ClientProfile from 'views/scenes/profile/ClientProfile';

const App = (props) => {
  return (
    <>
      <Helmet>
        <title>{translate('profile.Helmet.title')}</title>
      </Helmet>
      <ClientProfile />
    </>
  );
};

export default App;
